import { api, sp } from "./_base";


export const getAlloySNMPByConfig = async (configId, schemaName = null) => {
  try {
    const response = await api.get(`/alloy-snmp/`, { params: { alloy_config: configId, ...sp(schemaName) } });
    return response.data;
  } catch (error) {
    console.error("Error fetching SNMP jobs:", error);
    throw error;
  }
};

export const getAlloySNMPById = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/alloy-snmp/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error fetching SNMP job:", error);
    throw error;
  }
};

export const createAlloySNMP = async (data, schemaName = null) => {
  try {
    const response = await api.post("/alloy-snmp/", data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error creating SNMP job:", error);
    throw error;
  }
};

export const updateAlloySNMP = async (id, data, schemaName = null) => {
  try {
    const response = await api.put(`/alloy-snmp/${id}/`, data, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error updating SNMP job:", error);
    throw error;
  }
};

export const deleteAlloySNMP = async (id, schemaName = null) => {
  try {
    const response = await api.delete(`/alloy-snmp/${id}/`, { params: sp(schemaName) });
    return response.data;
  } catch (error) {
    console.error("Error deleting SNMP job:", error);
    throw error;
  }
};
